export default function ClockIcon({}) {
  return (
    <>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.25 21C16.9444 21 20.75 17.1944 20.75 12.5C20.75 7.80558 16.9444 4 12.25 4C7.55558 4 3.75 7.80558 3.75 12.5C3.75 17.1944 7.55558 21 12.25 21ZM12.25 20.0556C16.4228 20.0556 19.8056 16.6728 19.8056 12.5C19.8056 8.32718 16.4228 4.94444 12.25 4.94444C8.07718 4.94444 4.69444 8.32718 4.69444 12.5C4.69444 16.6728 8.07718 20.0556 12.25 20.0556Z"
          fill="white"
        />
        <path d="M12.25 7.5V13.5H16.25" stroke="white" />
        <path d="M12.25 4.5V2M9.25 2H15.25" stroke="white" />
        <path
          d="M18.8405 7.34876L20.7247 5.82818M18.9 3.56714L22.5494 8.08922"
          stroke="white"
        />
      </svg>
    </>
  );
}
